<template>
  <div class="input-pad">
    <input
      ref="input"
      :name="property"
      type="text"
      v-bind="getAttributes"
      @click="setCurrentInputPad(
                {
                  item,
                  property,
                  element: $event.target,
                  maxLength: maxLength ? maxLength : 20,
                  alphabetable,
                  usingDecimal
                })"
      @focus="onFocus"
      v-model="item[property]" />
      <span class="text-danger" v-if="error">{{ error }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SET_CURRENT_INPUT_PAD } from '@/store/mutation-types';
import CommonService from '@/services/CommonService';
export default {
  name: 'InputPad',
  props: ['id', 'item', 'property', 'attributes', 'maxLength', 'error', 'alphabetable', 'usingDecimal'],
  computed: {
    getAttributes() {
      return this.attributes;
    },
    ...mapState({
      inputHolderFocusing: state => state.inputPad.inputHolderFocusing,
    }),
    itemProperty() {
      return this.item ? this.item[this.property] : null;
    }
  },
  methods: {
    setCurrentInputPad(config) {
      this.$store.commit(SET_CURRENT_INPUT_PAD, config);
    },
    onFocus(event) {
      if (!this.isMobile()) {
        event.target.blur();
      }
    },
    isMobile() {
      return CommonService.checkMobile();
    },
  },
  watch: {
    inputHolderFocusing(newState) {
      //this.$forceUpdate();
    },
    itemProperty(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },
  $_veeValidate: {
    name() {
      return this.property;
    },
    value() {
      return this.itemProperty;
    },
  },
};
</script>
